import { v5 as uuid5 } from 'uuid';

/**
 * Generate a predictable UUID
 * @param value The string to compute a UUID for within the given namespace
 */
export function predictableUUID(value: string): string {
  return uuid5(value, window.env.UUID_V5_NAMESPACE);
}
